import React, { Component } from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";
import EndUser from 'utils/eusign'
import attention from "../../assets/icons/icons/light/svg/expand.svg";
import ReactSVG from 'react-svg'



import Button from "@material-ui/core/Button"

class FixedPlugin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: "dropdown show",
      bg_checked: true,
      bgImage: this.props.bgImage,
      euSign: ''
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.props.handleFixedClick(this.state.euSign);
    // console.log(this.state.euSign)
  }

  componentDidMount() {
           /*
  Ідентифікатор батківського елементу для відображення iframe, 
  який завантажує сторінку SignWidget
  */
 const SIGN_WIDGET_PARENT_ID		= "sign-widget-parent";
 /*
 Ідентифікатор iframe, який завантажує сторінку SignWidget
 */
 const SIGN_WIDGET_ID			= "sign-widget";
 /*
 URI з адресою за якою розташована сторінка SignWidget
 */
 const SIGN_WIDGET_URI			= "https://eu.iit.com.ua/sign-widget/v20200311";
//  const SIGN_WIDGET_URI			= "https://id.gov.ua/sign-widget";
 
 //=============================================================================
 
 /*
 Створення об'єкту типу EndUser для взаємодії з iframe, 
 який завантажує сторінку SignWidget
 */
 var euSign = new EndUser(
 SIGN_WIDGET_PARENT_ID, 
 SIGN_WIDGET_ID, 
 SIGN_WIDGET_URI,
 EndUser.FormType.ReadPKey
 );
 //euSign.destroy()
 this.setState({euSign})
  }

  render() {
    return (
      <div
        className={"fixed-plugin"}
      >
        <div id="fixedPluginClasses" className={this.props.fixedClasses}>
          <div onClick={this.handleClick}>
            {/* <i className="fa fa-cog fa-2x" /> */}
            {/* <ReactSVG
                      svgStyle={{
                      display: "inline-block",
                      }}
                      src={attention}
                      width="50"
                    />  */}
                    Підпис файлів
                   
          </div>
          <ul className="dropdown-menu">
            <li className="header-title">Підпис файлів</li>
            <li className="adjustments-line">
            <div id="sign-widget-parent" style={{width:"550px", height:"500px"}}/>
            </li>
            

         
          

            <li className="header-title" id="sharrreTitle">
           
            </li>

            
          </ul>
        </div>
      </div>
    );
  }
}

export default FixedPlugin;
